// extracted by mini-css-extract-plugin
export var completionBody = "_em-2";
export var completionCard = "_em-0";
export var completionFooter = "_em-3";
export var completionTitle = "_em-1";